// extracted by mini-css-extract-plugin
export default {"container":"tGY0Ro","headerContainer":"n1OoQZ","commentCount":"jwha3G","text":"cjIZgF","buttonContainer":"VohbWq","errorCode":"JxPAEd"};